import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FakturPajakMasukanComponent } from './faktur-pajak-masukan.component';
import { HttpClientModule } from '@angular/common/http';
import { NgQrScannerModule } from 'angular2-qrscanner';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule,
  MatDialogModule,
  MatButtonModule,
  MatCardModule,
  MatSlideToggleModule,
  MatSelectModule,
  MatFormFieldModule,
  MatToolbarModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatInputModule,
  MatTooltipModule,
  MatListModule,
  MatMenuModule,
} from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxQRCodeModule} from 'ngx-qrcode2';
import { AdjustPeriodePajakComponent } from './adjust-periode-pajak/adjust-periode-pajak.component';


@NgModule({
  imports: [
    MatMenuModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgQrScannerModule,
    MatTableModule,
    MatCardModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatDialogModule,
    MatFormFieldModule,
    FlexLayoutModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTooltipModule,
    NgxQRCodeModule,
    MatListModule
  ],
  declarations: [FakturPajakMasukanComponent, DialogComponent, AdjustPeriodePajakComponent],
  exports: [FakturPajakMasukanComponent],
  entryComponents: [DialogComponent, AdjustPeriodePajakComponent]
})
export class FakturPajakMasukanModule { }



// WEBPACK FOOTER //
// ./src/app/faktur-pajak-masukan/faktur-pajak-masukan.module.ts